window.addEventListener("load", (event) => {
  console.log('page loaded');
  const swatchBackgrounds = document.querySelectorAll('span.swatch-item');  
  if(swatchBackgrounds) {
    swatchBackgrounds.forEach((swatch) => {
        let bg = swatch.style.backgroundImage.split('"')[1];
        if(bg.includes('/t/4/assets/')){
           bg = bg.replace('/t/4/assets/', '/t/14/assets/');
           }
        //console.log('bg:', bg);
        swatch.style.backgroundImage = "url(" + bg + ")"
      });
    }
    
});

